module.exports = __webpack_public_path__ + "media/images/map/payment2-267965277fc1e7e5e505a503de903352.svg";